import styled from 'styled-components';
import {
  breakpoints,
  headerHeightMobile,
  headerHeightDesktop
} from '../../styles';
import { Modal } from 'semantic-ui-react';

// Section needs margin top or else it overlaps with the 3 category header due to negative margin from semantic UI.
export default styled(Modal)`
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  /* namespaced styles */
  &.streammodal {
    &--active {
      opacity: 1;
    }

    /* using the top position from .button--fixed */
    &--slide.ui.modal {
      top: ${headerHeightMobile * 2}rem;
      @media only screen and (min-width: ${breakpoints.tablet}) {
        top: ${headerHeightDesktop * 2};
        right: 0;
        transform: translateX(100vw);
        &.streammodal--active {
          transform: translateX(0);
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/StreamModal/StreamModal.style.js